exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Setting a text color here goes dark-on-dark: the toast class supplies it. */\n\n._3bDesdfR3xdPrZF3d6RM-r {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n", ""]);

// Exports
exports.locals = {
	"message": "_3bDesdfR3xdPrZF3d6RM-r"
};